import React, { useState } from "react";
import InnerBanner from "../../common/InnerBanner";
import ProductNav from "./ProductNav";
import ProductsGrid from "../Home/ProductsGrid";
import ProductList from "../Home/ProductList";
import Pagination from "../../common/Pagination";

const Products = () => {
  const [view, setView] = useState("is4x4");
  const [activePg, setActivePg] = useState(1);
  return (
    <div className="product_page">
      <InnerBanner name="Products" />
      <ProductNav setView={setView} />
      {view === "list" ? (
        <ProductList />
      ) : (
        <div className={view}>
          <ProductsGrid
            is3x3={view === "is3x3" ? true : false}
            isHome={false}
          />
        </div>
      )}
      <Pagination setActivePg={setActivePg} activePg={activePg} />
    </div>
  );
};

export default Products;
